import React, { useState, useEffect } from 'react'
import { useLocation, Switch, Route, Redirect } from 'react-router-dom'
import AdminNavbarAlternative from 'components/argon/Navbars/AdminNavbarAlternative.js'
import Sidebar from 'components/argon/Sidebar/Sidebar.js'
import Box from '@material-ui/core/Box'
import DashboardIcon from '@material-ui/icons/Dashboard'
import DeliveriesIcon from '@material-ui/icons/CheckBox'
import PaymentsIcon from '@material-ui/icons/Payment'
import ReplacementsIcon from '@material-ui/icons/Autorenew'
import AllocationsIcon from '@material-ui/icons/CalendarToday'
import AnalyticsIcon from '@material-ui/icons/BarChart'
import PeopleIcon from '@material-ui/icons/People'
import BoardsIcon from '@material-ui/icons/ZoomIn'
import SettingsIcon from '@material-ui/icons/Settings'
import DownloadIcon from '@material-ui/icons/GetApp'

import logo from 'resources/images/logo-blue-500.png'

import { makeStyles } from '@material-ui/core/styles'
import componentStyles from 'assets/theme/layouts/admin.js'

import Dashboard from 'scenes/admin/Dashboard'
//import Companies from 'scenes/admin/Companies'
import Replacements from 'scenes/admin/Replacements'
import Payments from 'scenes/admin/Payments'
import Profitability from 'scenes/admin/Profitability'
import Leads from 'scenes/admin/Leads'
import LeadBoards from 'scenes/admin/LeadBoards'
import ExportLeads from 'scenes/admin/ExportLeads'
import NationalPensionHelpline from 'scenes/admin/NationalPensionHelpline'
import StartPension from 'scenes/admin/StartPension'
import CompareInsurance from 'scenes/admin/CompareInsurance'
import EnergyEfficiency from 'scenes/admin/EnergyEfficiency'
import Settings from 'scenes/admin/Settings'
import EnergyDeliveries from 'scenes/admin/EnergyDeliveries'
import FSDeliveries from 'scenes/admin/FSDeliveries'
import SolarReactivation from 'scenes/admin/SolarReactivation'
import SandboxLeads from 'scenes/tester/SandboxLeads'
import BoltIcon from '@material-ui/icons/FlashOn'

const useStyles = makeStyles(componentStyles)

const Main = (props) => {
    const classes = useStyles()
    const location = useLocation()
    const [sidebarOpenResponsive, setSidebarOpenResponsive] = useState(false)

    useEffect(() => {
        document.documentElement.scrollTop = 0
        document.scrollingElement.scrollTop = 0
        // mainContent.current.scrollTop = 0
    }, [location])

    var routes = [
        {
            path: '/dashboard',
            name: 'Dashboard',
            icon: DashboardIcon,
            iconColor: 'Info',
            component: Dashboard,
        },
        {
            path: '/leads',
            name: 'Leads',
            icon: PeopleIcon,
            iconColor: 'Info',
            component: Leads,
        },
        {
            path: '/lead-boards',
            name: 'Lead Boards',
            icon: BoardsIcon,
            iconColor: 'Info',
            component: LeadBoards,
        },
        {
            path: '/export-leads',
            name: 'Export Leads',
            icon: DownloadIcon,
            iconColor: 'Info',
            component: ExportLeads,
            invisible: true,
        },
        {
            path: '/replacements',
            name: 'Replacements',
            icon: ReplacementsIcon,
            iconColor: 'Info',
            component: Replacements,
        },
        {
            path: '/fs-deliveries',
            name: 'FS Deliveries',
            icon: DeliveriesIcon,
            iconColor: 'Info',
            component: FSDeliveries,
        },
        {
            path: '/energy-deliveries',
            name: 'Energy Deliveries',
            icon: BoltIcon,
            iconColor: 'Info',
            component: EnergyDeliveries,
        },
        {
            path: '/solar-reactivation',
            name: 'Solar Reactivation',
            icon: BoltIcon,
            iconColor: 'Info',
            component: SolarReactivation,
        },
        {
            path: '/invoices',
            name: 'Invoices',
            icon: PaymentsIcon,
            iconColor: 'Info',
            component: Payments,
        },
        {
            path: '/profitability',
            name: 'Profitability',
            icon: AnalyticsIcon,
            iconColor: 'Info',
            component: Profitability,
        },
        {
            path: '/nph',
            name: 'NPH',
            icon: DashboardIcon,
            iconColor: 'Info',
            component: NationalPensionHelpline,
        },
        {
            path: '/pension-compare',
            name: 'Pension Compare',
            icon: DashboardIcon,
            iconColor: 'Info',
            component: StartPension,
        },
        {
            path: '/compare-insurance',
            name: 'Compare Insurance',
            icon: DashboardIcon,
            iconColor: 'Info',
            component: CompareInsurance,
        },
        {
            path: '/energy-efficiency',
            name: 'Energy Efficiency',
            icon: DashboardIcon,
            iconColor: 'Info',
            component: EnergyEfficiency,
        },
        {
            path: '/settings',
            name: 'Settings',
            icon: SettingsIcon,
            iconColor: 'Info',
            component: Settings,
        },
        {
            path: '/sandbox-leads',
            name: 'Sandbox Leads',
            icon: PeopleIcon,
            iconColor: 'Info',
            component: SandboxLeads,
        },
    ]

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.divider || prop.title) {
                return null;
            }
            if (prop.collapse) {
                return getRoutes(prop.views)
            } 
            else {
                return (
                    <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                    />
                )
            }
        });
    };

    return (
        <>
            <Box display='flex'>
                <Sidebar
                    routes={routes}
                    openResponsive={sidebarOpenResponsive}
                    closeSidebarResponsive={() => setSidebarOpenResponsive(false)}
                    accountType='admin'
                    logo={{
                        innerLink: '/',
                        imgSrc: logo,
                        imgAlt: '...',
                        className: 'sidebar-logo',
                    }}
                />
                <Box position='relative' flex='1' className={classes.mainContent}>
                    <AdminNavbarAlternative
                        openSidebarResponsive={() => setSidebarOpenResponsive(true)}
                        accountType='admin'
                        //permissions={details.permissions}
                        name={'Admin'}
                    />
                    
                    <Switch>
                        {getRoutes(routes)}
                        <Redirect from='*' to='/leads' />
                    </Switch>
                </Box>
            </Box>
        </>
    )
}

export default Main